<template>
	<div class="single">
		<div class="single__container">
			<h1>{{this.event.productName}}</h1>
			<div class="single__row">
				<div class="single__col">
					<img :src="this.event.multimedia[0].serverPath" alt="">
				</div>
				<div class="single__col">
					<div id="map">
						<google-map :lat="this.event.addresses[0].geocodeGdaLatitude" :lng="this.event.addresses[0].geocodeGdaLongitude"></google-map>
					</div>
					<div class="single__col__map-content">
						<p>{{this.event.addresses[0].addressLine1}}, {{this.event.addresses[0].cityName}}, {{this.event.addresses[0].countryName}}</p>
						<a target="_blank" :href="'https://maps.google.com?saddr=Current+Location&daddr='+event.addresses[0].geocodeGdaLatitude+','+event.addresses[0].geocodeGdaLongitude">Get Directions</a>
					</div>
				</div>
			</div>
			<div class="single__row">
				<div class="single__row__date">
					<p>
						{{date(this.event.startDate)}}
						<span v-if="this.event.frequencyStartDate !== this.event.frequencyEndDate"> - {{date(this.event.frequencyEndDate)}}</span>
						|
						<span v-if="this.event.eventFrequency[0].frequencyStartTime">{{this.event.eventFrequency[0].frequencyStartTime}} - {{ this.event.eventFrequency[0].frequencyEndTime}}</span>

						<span v-if="this.event.eventFrequency.length > 0" style="margin-left: 30px;">
							MORE DATES:
						</span>
						<span v-for="(freq, index) in event.eventFrequency" class="more-dates" v-if="(new Date(freq.frequencyStartDate) > Date.now()) && new Date(freq.frequencyStartDate) != new Date(event.frequencyEndDate)">
							{{moreDate(freq.frequencyStartDate)}}
						</span>

					</p>
				</div>

				<div class="single__row__social">

					<span v-if="this.event.externalSystems[0] !== undefined && this.event.externalSystems[0].externalSystemCode == 'FACEBOOK'">
						<a target="_blank" :href="this.event.externalSystems[0].externalSystemText" class="single__row__social--facebook">
							<img src="/img/facebookicon.svg" style="width: 15px; height: 27px;" alt="">Facebook
						</a>
					</span>
					<span v-for="(com) in this.event.communication">

						<a target="_blank" v-if="com.attributeIdCommunicationDescription == 'Email Enquiries'" :href="'mailto:'+com.communicationDetail" class="single__row__social--email">
							<img src="/img/e-mailicon.svg" style="width: 27px; height; 18px;" alt=""> Email
						</a>

						<a target="_blank" v-if="com.attributeIdCommunicationDescription == 'Email Enquiries'" :href="'mailto:'+com.communicationDetail" class="single__row__social--email">
							<img src="/img/e-mailicon.svg" style="width: 27px; height; 18px;" alt=""> Email
						</a>

						<a target="_blank" v-if="com.attributeIdCommunicationDescription == 'URL Enquiries'" :href="com.communicationDetail.indexOf('http') > -1 ? com.communicationDetail : 'http://'+com.communicationDetail" class="single__row__social--website">
							<img src="/img/globeicon.svg" style="width: 30px; height: 30px;" alt=""> Website
						</a>

						<a target="_blank" v-if="com.attributeIdCommunicationDescription == 'Primary Phone'" :href="'tel:'+com.communicationDetail" class="single__row__social--phone">
							<img src="/img/phoneicon.svg" style="width: 27px; height: 27px;" alt=""> {{com.communicationDetail}}
						</a>

					</span>
				</div>
				<div class="single__row__content">
					<p>{{this.event.productDescription}}</p>
					<router-link :to="{
						name: 'events',
						params: {
							checkedCategory: checkedCategory,
							checkedLocation: checkedLocation,
							keywords: keywords,
							dateTo: dateTo,
							dateFrom: dateFrom
						}
					}" >Back to Events</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script type="text/javascript">
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'
import GoogleMap from "./map";
export default {
	name: 'single-listing',
	components: {
		GoogleMap
	},
	data() {
		return {
			event: {},
			checkedCategory: [],
			checkedLocation: [],
			keywords: '',
			dateTo: '',
			dateFrom: ''
		}
	},
	computed: {

	},
	methods: {
		getEvent() {
			this.event = this.$route.params.event
			this.checkedCategory = this.$route.params.checkedCategory
			this.checkedLocation = this.$route.params.checkedLocation
			this.keywords = this.$route.params.keywords
			this.dateTo = this.$route.params.dateTo
			this.dateFrom = this.$route.params.dateFrom
			if(this.event == null || this.event == undefined || !this.event.length) {
				this.getEventAPI()
			}
			return this.event
		},
		getEventAPI() {
			let _this = this
			let productEndpoint = ''
			if(this.$route.params.id !== undefined) {
				productEndpoint = 'https://atlas.atdw-online.com.au/api/atlas/product?productId='+this.$route.params.id+'&key=baeec540167b4d0288efa39496d05e2c&out=json'
			} else {
				let fullUrl = document.location.href+this.$route.params.url.substr(1)
				let url = new URL(fullUrl)
				let id = url.searchParams.get("id")
				productEndpoint = 'https://atlas.atdw-online.com.au/api/atlas/product?productId='+id+'&key=baeec540167b4d0288efa39496d05e2c&out=json'
			}

			axios.get(productEndpoint)
				.then( (res) => {
					_this.event = res.data
				})
				.catch(function(error) {
					console.log(error)
				})
		},
		date(date) {
			return moment(date).format('D MMM YYYY')
	 	 },
		 moreDate(date) {
			 return moment(date).format('dddd, MMMM D')
		  }
	},
	mounted() {
		console.log('mounted')
	},
	created() {
		this.getEvent()
		console.log('created')
	}
}
</script>

<style media="screen" lang="scss">
	.single {
		padding: 0 1.50rem;
		font-family: 'Merlo Regular', sans-serif;
		h1 {
			font-family: 'Merlo Regular', sans-serif;
			font-weight: 700;
			margin-bottom: 40px;
			text-transform: uppercase;
		}
		p {
			font-family: 'Merlo Regular', sans-serif;
			font-size: 16px;
			font-weight: 100;
			letter-spacing: 0.5px;
			line-height: 22px;
		}
		a {
			font-family: 'Merlo Regular', sans-serif;
			font-weight: 700;
			letter-spacing: 0.5px;
		}
		&__container {
			max-width: 1140px;
			margin: auto;
			padding-top: 70px;
		}
		&__row {
			display: flex;
			flex-flow: row wrap;
			justify-content: space-between;
			align-items: flex-start;
			&__date {
				width: 100%;
				margin: 30px 0;
				p {
					font-weight: bold;
				}
			}
			&__social {
				display: flex;
				flex-flow: row wrap;
				justify-content: flex-start;
				margin-bottom: 30px;
				width: 100%;
				span {
					height: 40px;
					overflow: hidden;
					&:first-child {
						a {
							margin-left: 0;
						}
					}
				}
				a {
					display: flex;
					flex-flow: row;
					justify-content: center;
					align-items: center;
					color: #000000;
					font-size: 16px;
					font-weight: 100;
					letter-spacing: 0.5px;
					line-height: 22px;
					text-decoration: none;
					height: 40px;
					margin-right: 40px;
					img {
						margin-right: 15px;
						object-fit: contain;
					}
				}
			}
			&__content {
				width: 100%;
				p {
					font-weight: 100;
					letter-spacing: 0.5px;
					line-height: 25px;
				}
				a {
					color: #4A79AC;
					border: 1px solid #C1D2E4;
					padding: 10px 15px;
					text-decoration: none;
					font-size: 14.08px;
					letter-spacing: 0.44px;
					line-height: 17px;
					display: inline-block;
					margin-top: 30px;
					&:hover {
						background-color: #4A79AC;
						color: #ffffff;
					}
				}
			}
		}
		&__col {
			width: 48.5%;
			height: 420px;
			@media all and (max-width: 768px) {
				width: 100%;
				margin-bottom: 30px;
			}
		}
		&__col__map-content {
			background-color: #4A79AC;
			padding: 15px 30px;
			P {
				margin-top: 0;
				margin-bottom: 10px;
				color: #ffffff;
			}
			a {
				color: #ffffff;
			}
		}
		img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}
		.more-dates {
			padding: 0 10px;
			border-right: solid black 1px;
			line-height: 40px;
			&:last-child {
				border-right: none;
			}
		}
	}
</style>
